import React from "react";
import "./index.css";
import { HashLink as Link } from "react-router-hash-link";
import behance from "./assets/Behancefooter.png";
import github from "./assets/GitHubfooter.png";
import linkedin from "./assets/LinkedInfooter.png";
import twitter from "./assets/Twitterfooter.png";

function Footer() {
  return (
    <footer className="footer bg-primary p-5">
      <section className="footer-content flex flex-col gap-y-8 items-start md:items-center">
        <h3 className="text-body text-white font-semibold">
          Oh you scrolled the way down? That’s some dedication :)
        </h3>
        <p className="text-small text-white font-light">
          Thanks for your interest. If you would like to discuss more or give
          any feedbacks, reach me out in my social media.
        </p>
        <section className="social-link flex flex-row gap-x-8">
          <a
            href="https://www.linkedin.com/in/rizqy-fachri/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img class="footerImage w-8" src={linkedin} alt="Linkedin"></img>
          </a>
          <a
            href="https://twitter.com/rizqyf_"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img class="footerImage w-8" src={twitter} alt="Twitter"></img>
          </a>
          <a
            href="https://www.behance.net/rizqy-fachri"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img class="footerImage w-8" src={behance} alt="Behance"></img>
          </a>
          <a
            href="https://github.com/Rizqyfm"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img class="footerImage w-8" src={github} alt="Behance"></img>
          </a>
        </section>
        <section className="footer-link flex flex-row gap-x-8 text-white text-small underline">
          <Link className="anchorLink" to="/About" smooth activeStyle>
            About me
          </Link>
          <Link className="anchorLink" to="/Works" smooth activeStyle>
            Works
          </Link>
          <a
            href="https://drive.google.com/file/d/10ILl7x_zLnNhJj73hV4m7p0ZO4pvcXsx/view?usp=sharing"
            target="_blank"
            className="resumeLink"
            rel="noopener noreferrer"
          >
            Resume
          </a>
        </section>
      </section>
    </footer>
  );
}

export default Footer;
